import { render, staticRenderFns } from "./brandAndSeriesCascader.vue?vue&type=template&id=6fbb1f16"
import script from "./brandAndSeriesCascader.vue?vue&type=script&lang=js"
export * from "./brandAndSeriesCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports